// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app__wrapper___2Pp0c","header":"app__header___3YeA9","shortcuts-area":"app__shortcuts-area___y1IZ6","shortcutsArea":"app__shortcuts-area___y1IZ6","main-area":"app__main-area___1IOtA","mainArea":"app__main-area___1IOtA","options-area":"app__options-area___2vPCv","optionsArea":"app__options-area___2vPCv","footer":"app__footer___jl1Mn"};


//////////////////
// WEBPACK FOOTER
// ../stylesheet/css/header-builder/app.css
// module id = 862
// module chunks = 0